"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmptyDetailContainer = void 0;
const react_1 = __importStar(require("react"));
const react_intl_1 = require("react-intl");
const lodash_1 = require("lodash");
const Typography_1 = __importDefault(require("@material-ui/core/Typography"));
const evidence_defaults_context_1 = require("../evidence-defaults/evidence-defaults-context");
const detail_styles_1 = require("./detail-styles");
const detail_context_1 = require("./detail-context");
function EmptyDetailContainer() {
    const classes = detail_styles_1.useStyles();
    const context = react_1.useContext(detail_context_1.DetailContext);
    const { showButton = lodash_1.stubTrue, disableButton = lodash_1.stubFalse, source } = context;
    const { logo } = react_1.useContext(evidence_defaults_context_1.EvidenceDefaultsContext);
    const canCreate = (showButton === null || showButton === void 0 ? void 0 : showButton({ button: 'NEW', source })) &&
        !(disableButton === null || disableButton === void 0 ? void 0 : disableButton({ button: 'NEW', source }));
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: classes.blankScreen },
            logo !== undefined && (react_1.default.createElement("img", { src: logo, alt: "logo", className: classes.logo })),
            react_1.default.createElement(Typography_1.default, { variant: "body1", align: "center" },
                react_1.default.createElement(react_intl_1.FormattedMessage, { id: "EAS_DETAIL_EMPTY_CONTAINER_MSG", defaultMessage: "Vyberte n\u011Bkterou z <b>polo\u017Eek ze seznamu vlevo</b> {canCreate, select, true {, nebo klikn\u011Bte na tla\u010D\u00EDtko <b>NOV\u00DD</b>} other {}}.", values: { canCreate } })))));
}
exports.EmptyDetailContainer = EmptyDetailContainer;
//# sourceMappingURL=empty-detail-container.js.map